<app-page-topbar [title]="'Performance'" [menu]="">
    <ng-container *ngIf="showSwitch">
        <div *appDesktop class="btn-secondary-simple flex gap-2" (click)="toggleBetaView()">
            <span *ngIf="!isBeta">
                <i class="pi pi-chart-bar icon-large mr-1"></i>
                Try Beta Stats
            </span>
            <span *ngIf="isBeta">
                Back to Classic
            </span>
        </div>
    </ng-container>
    <ng-container *ngIf="isBeta && performanceOverviewComponent?.isSingleStatMode">
        <div *appDesktop class="button" (click)="exportInsightsPDF()">
            <span>Export Insights</span>
            <img src="/assets/icon/icon-export-pdf-arrow.svg" alt="Export" />
        </div>
    </ng-container>
    
</app-page-topbar>

<ng-container *ngIf="!isBeta">
    <app-performance-legacy>
    </app-performance-legacy>
</ng-container>

<ng-container *ngIf="isBeta">
    <app-performance-overview>
    </app-performance-overview>
</ng-container>
